module.exports = __webpack_public_path__ + "img/taobao.2829fc57.png";